import { Navigate } from 'react-router-dom';

/**
 * Role Guard Component
 *
 * Protects routes by checking if the user's role is in the allowed roles list.
 * Redirects to /not-found if the user doesn't have access.
 *
 * @param {Array<string>} allowedRoles - Array of roles that can access the route
 * @param {React.ReactNode} children - The protected component
 */
const RoleGuard = ({ allowedRoles, children }) => {
  const userType = localStorage.getItem('userType');

  // Check if user's role is in the allowed roles
  const hasAccess = allowedRoles.includes(userType);

  if (!hasAccess) {
    return <Navigate to="/not-found" replace />;
  }

  return children;
};

export default RoleGuard;
